var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PopularLiveSports from './PopularLiveSports';
import { bindActionCreators } from 'redux';
import { setDisplayMode as setDisplayModeAction } from './../../../actions/creators/displayMode';
import { push } from 'react-router-redux';
import { sportSortFunc } from '../../../rendering-commons/Sorting';
var PopularLive = /** @class */ (function (_super) {
    __extends(PopularLive, _super);
    function PopularLive() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopularLive.prototype.render = function () {
        var _this = this;
        var _a = this.props, sports = _a.sports, gridLocalization = _a.gridLocalization, setDisplayModeAction = _a.setDisplayModeAction, push = _a.push;
        return (_jsx("div", __assign({ className: 'blc blc_best' }, { children: sports.sort(sportSortFunc).valueSeq().map(function (sport) {
                var sportId = sport.get('id');
                var sportName = sport.get('name');
                var matches = _this.props.matches.filter(function (m) { return sport.get('id') === m.get('sportId'); });
                var props = {
                    sportId: sportId,
                    sportName: sportName,
                    matches: matches,
                    gridLocalization: gridLocalization,
                    setDisplayModeAction: setDisplayModeAction,
                    push: push
                };
                return _jsx(PopularLiveSports, __assign({}, props), "grouped-".concat(sport.get('id')));
            }) })));
    };
    return PopularLive;
}(React.Component));
PopularLive.propTypes = {
    gridLocalization: PropTypes.object.isRequired,
    matches: PropTypes.object.isRequired,
    sports: PropTypes.object.isRequired,
};
function mapStateToProps(state) {
    var popularLive = state.application.get('popularLive');
    var matches = new Map();
    popularLive.map(function (item) {
        matches = matches.update(item.eid, function () { return state.application.getIn(['live', 'matches', item.eid]); });
    });
    var sports = state.application.getIn(['live', 'sports']).filter(function (s) { return matches.get('sportId') === s.id; });
    return {
        matches: matches,
        sports: sports
    };
}
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    push: push,
    setDisplayModeAction: setDisplayModeAction
}, dispatch); };
PopularLive = connect(mapStateToProps, mapDispatchToProps)(PopularLive);
export default PopularLive;



// WEBPACK FOOTER //
// ./src/components/grid/popular/PopularLive.jsx